function initAuth() {
  const authForm = document.querySelector('.auth__form');

  if (!authForm) {
    return;
  }

  authForm.addEventListener('submit', (e) => {
    e.preventDefault();

    if (authForm.email.value && authForm.password.value) {
      window.location.href = 'index.html';
    } else {
      authForm.classList.add('is-error');
    }
  });
}

export {initAuth};
